import React, { useEffect, useState, useCallback } from 'react';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { Input, Space, Card, Col, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { ProductsTable } from '@app/components/apps/Products/ProductsTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { CrudSettingsContext } from '@app/contexts/CrudSettingsContext';
import { CrudSettings } from '@app/models/CrudSettings';
import ProductsForm from '@app/components/apps/Products/ProductsForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

const AllProducts: React.FC = () => {
  const [settings, setSettings] = useState<CrudSettings>({
    mode: 'list',
    id: null,
  });

  const { setBreadcrumb, addHeaderButton, removeHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('');

  function handleCreateClick(): void {
    navigate('/add-product');
  }

  const pageTitle = () => {
    switch (settings.mode) {
      case 'create':
        return 'Create Product';
      case 'edit':
        return 'Edit Product';
      case 'view':
        return 'View Product';
      default:
        return 'Products';
    }
  };

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb routes={[{ path: '/products', breadcrumbName: pageTitle() }]} style={{ marginBottom: '15px' }} />,
    );

    addHeaderButton(
      'Create',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [settings.mode]);

  return (
    <>
      <PageTitle>Products</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CrudSettingsContext.Provider value={{ settings, setSettings }}>
            {settings.mode !== 'list' ? (
              <ProductsForm
                pageTitle={pageTitle()}
                editable={false}
                type={'edit'}
                setCurrentBreadcrumName={setCurrentBreadcrumName}
              />
            ) : (
              <ProductsTable />
            )}
          </CrudSettingsContext.Provider>
        </Col>
      </Row>
    </>
  );
};

export default AllProducts;
